/* eslint-disable */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js";
import React from "react";
import ReactDOM from "react-dom";

import { Root } from "./Root";

import * as serviceWorker from "./serviceWorker";
import "./index.css";
import { saveToken } from "./modules/auth";


declare global {
  interface Window {
    setAuthToken: (token: string) => void;
  }
}


(function() {

  // проверяем поддержку
  var prototype: any = Element.prototype;
  if (!prototype.matches) {
    // определяем свойство
    prototype.matches = prototype.matchesSelector ||
      prototype.webkitMatchesSelector ||
      prototype.mozMatchesSelector ||
      prototype.msMatchesSelector;

  }

})();

(function() {

  // проверяем поддержку
  if (!Element.prototype.closest) {

    // реализуем
    Element.prototype.closest = function(css : any) {
      var node: any = this;

      while (node) {
        if (node.matches(css)) return node;
        else node = node.parentElement;
      }
      return null;
    };
  }

})();

window.setAuthToken = function (token: string) {
  saveToken(token);
  console.log('set auth token', token);
}

ReactDOM.render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
